// extracted by mini-css-extract-plugin
module.exports = {"triangle":"_2BZN8","outer":"UyE6i","inner":"_1pwEH","right":"_29BzJ","left":"_3o3sX"};